import api, { ServerResponse } from "./agritech";

async function listMetrics(token: string) {
  const response = await api.get<ServerResponse<ServerMetric[]>>(`/metrics`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

export type ServerMetric = {
  ref: string;
  color: string;
  short_name: string;
  limits: string;
  thresholds: string;
};

async function searchMetrics(
  params: { raw: 0 | 1; modules: number[] },
  token: String
) {
  const response = await api.post<ServerResponse<ServerMetric[]>>(
    `/metrics`,
    { ...params },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
}

export { listMetrics, searchMetrics };
